export const tile = {
    bgcolor: 'rgba(255,255,255,0.08)',
};

export const dimText = {
    bgcolor: 'rgba(255,255,255,0.14)',
};

export const button = {
    height: 40,
    borderRadius: '10px',
    flex: 1,
};

export const shareButton = {
    height: 40,
    width: 40,
    borderRadius: '999px',
};
